import Vue from 'vue';

export const upperCase = (v: string | null | undefined) => (v ? v.toUpperCase() : '');
export const euroPrice = (v: string | number | null | undefined) => (v ? `${v} €` : '');

Vue.filter('UpperCase', upperCase);
Vue.filter('EuroPrice', euroPrice);
